<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "App"
};
</script>

<style scoped lang="scss">
#app {
  min-height: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue